import React from "react";
import { userprofile, Verifyemailmobile } from "../../Model/Users"; //Include Home
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { UserchangeSendpin } from "../../Model/Users";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import * as CountryCode from "../../Config/CountryCode.js";
import { Link } from "react-router-dom";
import Enterpincode from "./Enterpincode";
import BarLoader from "react-spinners/BarLoader";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));
class Verifyemail extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      fields: {
        fld_mobile: "",
        country_code: "+91",
        fld_email: "",
        fld_password: "",
      },
      errors: { isValidEmailerror: false, isValidEmailerror: false },
      msg: { alreadyRegiter: false, validpasswordMsg: false },
      showEnterpin: false,
      isValidEmail: false,
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      ButtonDisable: true,
      SuccessMobileChange: false,
      RequestType: "verify"
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      let data = {
        seesionID:localStorage.getItem("session_id"),
        userID:localStorage.getItem("userID")
      }
      userprofile(data).then((userprofile) => {
        if (userprofile.data.success == false) {
          this.props.navigate("/manage-profile");
        } else {
          var postdata = {
            verifyEmail: true,
          }
          Verifyemailmobile(postdata).then((response) => {
            var Response = JSON.parse(response.data);
            if (Response.success == true) {
              //Show pin-enter
              this.setState({
                VirsionCheckData: vcheckres,
                VirsionCheckDataloaded: true,
                DataisLoaded: true,
                ProfileData: userprofile,
                showEnterpin: true
              });
            } else {
              //Something went wrong

            }

          })

        }
      });
    });
  }

  handleChange(e) {

    const fields = this.state.fields;
    if (e.target.name == "fld_email" && /\s/.test(e.target.value) == false) {
      const emailRegex = /\S+@\S+\.\S+/;
      if (emailRegex.test(e.target.value) && /\s/.test(e.target.value) == false) {

        this.setState({
          isValidEmail: true,
          ButtonDisable: false,
        });
      } else {
        this.setState({
          isValidEmail: false,
          ButtonDisable: true,
        });
      }

    }

    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }
  CustomeBackButton() {
    this.setState({
      showEnterpin: false,
    });
  }
  /*-------Logout-------*/
  backbtn() {
    this.props.navigate("/manage-profile");
  }
  backbtn1() {
    this.props.navigate("/profile");
  }
  popupshow() {
    this.setState({ SuccessMobileChange: true, showEnterpin: false });
  }


  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else if (this.state.showEnterpin) {
      return <Enterpincode data={this} title="Verify" />;
    } else {
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <header>
                <div className="mainNav pmenu dD-none">
                  <div className="docubayBack white">
                    <Link to="/manage-profile">
                      <img src="img/svg/back.svg" alt="DocuBay" />
                    </Link>{" "}
                    Change Email Address
                  </div>
                </div>
              </header>
              <main>
                {/* <section className="mb-0">
                  <div className="homeBanner">
                    <div className="innerBanner mb-0">
                      <div className="title-mail">
                        <h1>
                          Change <span className="red">Email Address</span>
                        </h1>
                        <div className="reset">
                          Enter the new email address that will be linked to
                          your DocuBay account.We will send a verification code
                          to this email address, please enter that code below for verification.
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}
                <section style={{ paddingBottom: 45 }}>
                  <div className="temp31">
                    <div className="temp31Inner">
                      <div
                        className={
                          this.state.errors.isValidEmailerror
                            ? " formField error-border data"
                            : true
                              ? "formField data "
                              : "formField data "
                        }
                        ref={this.emailInput}
                      >

                        <input
                          name="fld_email"
                          type="text"
                          className="fld_email"
                          placeholder="Enter new email address"
                          value={this.state.fields.fld_email}
                          onChange={this.handleChange}
                          autoComplete="off"
                          autoComplete="new-password"
                          required
                        />
                      </div>
                      {this.state.errors.isValidEmailerror ? (
                        <div className="error error-verifyotp">
                          <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                          <p>{this.state.msg.alreadyRegiter} </p>
                        </div>
                      ) : null}
                      <div
                        className="passChangepopup dD-none"
                        style={{
                          display: this.state.SuccessMobileChange
                            ? "flex"
                            : "none",
                        }}
                        id="passChange"
                      >
                        <div className="temp31-modal-body">
                          <button
                            className="temp31-modal-close temp31-modal-toggle"
                            onClick={() => {
                              this.backbtn();
                            }}
                          >
                            <img
                              src={SVGIcon["promocode-close.svg"]}
                              alt="DocuBay"
                            />
                          </button>
                          <img
                            src={ImageData["email.png"]}
                            alt="DocuBay"
                            className="imgPass"
                          />
                          <div className="temp31-awesome">
                            <h5>Email address Verified!</h5>
                            <h6>Your email address has been Verified successfully</h6>
                          </div>
                          <Link
                            to="/"
                            type="submit"
                            id="sendEnquiryBtn"
                            className="btn-white"
                          >
                            Back to Home
                          </Link>
                        </div>
                      </div>
                      <div
                        className="passChangepopup dD-block"
                        style={{
                          display: this.state.SuccessMobileChange
                            ? "flex"
                            : "none",
                        }}
                        id="passChange"
                      >
                        <div className="temp31-modal-body">
                          <button
                            className="temp31-modal-close temp31-modal-toggle"
                            onClick={() => {
                              this.backbtn1();
                            }}
                          >
                            <img
                              src={SVGIcon["promocode-close.svg"]}
                              alt="DocuBay"
                            />
                          </button>
                          <img
                            src={ImageData["email.png"]}
                            alt="DocuBay"
                            className="imgPass"
                          />
                          <div className="temp31-awesome">
                            <h5>Email address Verified!</h5>
                            <h6>Your email address has been Verified successfully</h6>
                          </div>
                          <Link
                            to="/"
                            type="submit"
                            id="sendEnquiryBtn"
                            className="btn-white"
                          >
                            Back to Home
                          </Link>
                        </div>
                      </div>
                      <div className="formField mt-24 mb-24">
                        <a href="#" className="temp31-modal-toggle">
                          {" "}
                          <button
                            type="submit"
                            id="sendEnquiryBtn"
                            disabled={this.state.ButtonDisable}
                            className={
                              this.state.ButtonDisable ? "btn-black" : "btn-red"
                            }
                            onClick={() => {
                              this.checkuser();
                            }}
                          >
                            Verify
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </section>
              </main>
            </>
            {isMobile ? <Mobilemenu active="5" /> : <Profilemenu userdata={this.state.userData} />}

          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Verifyemail);
